import { createSlice } from "@reduxjs/toolkit";


const initialServiceState = {
    listLoading: false,
    actionsLoading: false,
    serviceItemTotalCount: 0,
    serviceItems: [], 
    error: null
  };

export const callTypes = {
  list: "list",
  action: "action"
};
  

const serviceSlice = createSlice({
    name: 'serviceItem',
    initialState:initialServiceState,
    reducers: {
        catchError: (state, action) => {
          state.error = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.error = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else {
            state.actionsLoading = true;
          }
        },
        serviceItemsFetched: (state, action) => {
          const { totalCount, serviceItems } = action.payload;
          state.listLoading = false;
          state.error = null;
          state.serviceItems = serviceItems;
          state.serviceItemTotalCount = totalCount;
        }
      }
});

export const { actions } = serviceSlice;
export const { reducer } = serviceSlice;